import { createAsyncThunk } from "@reduxjs/toolkit";
import { accidentAction } from "./AccidentSlice";
import { fetchAccidentSheetSettings } from "src/shared/services/src";
import { ChildrenStoreData } from "src/shared/types/src";


export const getAccidentSheetSettingsData = createAsyncThunk(
    "getAccidentSheetSettingsData", async ({ child }: { child: ChildrenStoreData }, { dispatch }) => {
        try {
            dispatch(accidentAction.setSettingsLoading(true));
            const response = await fetchAccidentSheetSettings({ child });

            if (response) {
                dispatch(accidentAction.setSettingsData(response))
            }
        } catch (error) {
            console.log("Error fetching accident settings: ", error);
        } finally {
            dispatch(accidentAction.setSettingsLoading(false));
        }
    }
)